<script lang="ts">
	import { ButtonGroup, Button } from '@Shelly/shelly-design-system/index';
	import { onSettingsResponse } from 'src/helpers/device_settings_helpers';
	import { save_home } from 'src/helpers/home_helpers';
	import type { DeviceListLayoutType } from 'src/helpers/new-layout-helpers';
	import { home_data } from 'src/stores/account/user';
	import { showNewLayout } from 'src/stores/toDelete/new_layout';

	export let disabled = false;

	let deviceListType: DeviceListLayoutType = $home_data?.['device_list']?.type || 'default';

	const onChangeDeviceListType = async (type: DeviceListLayoutType = 'default') => {
		if (disabled) return;
		if (deviceListType === type) return;

		const cached = deviceListType;
		deviceListType = type;

		const res = await save_home('device_list', {
			type: type,
		});

		if (!res.isok) {
			deviceListType = cached;
		}

		onSettingsResponse(res);
	};
</script>

{#if $showNewLayout}
	<ButtonGroup aria-label="Button group" class="pt-0 pb-0 pl-0 pr-0">
		<Button
			aria-label="icon"
			class={deviceListType === 'default' ? 'active' : undefined}
			size="m"
			icon="fas fa-list"
			leftIconSize="xs"
			{disabled}
			on:click={async () => {
				await onChangeDeviceListType('default');
			}}
		/>
		<Button
			aria-label="icon"
			class={deviceListType === 'compact' ? 'active' : undefined}
			size="m"
			icon="fas fa-grid-2"
			leftIconSize="xs"
			{disabled}
			on:click={async () => {
				await onChangeDeviceListType('compact');
			}}
		/>
	</ButtonGroup>
{/if}
